import { View, Text } from "@react-pdf/renderer";
import TextWrapperWithLineBreaks from "./text-wrapper-with-line-breaks.component";

type TextWrapperProps = {
  text?: string;
  style?: any;
  containerStyle?: any;
  allowLineBreaks?: boolean;
};
export default function TextWrapper({
  text,
  allowLineBreaks,
  style,
  containerStyle,
}: TextWrapperProps) {
  if (allowLineBreaks)
    return (
      <TextWrapperWithLineBreaks
        text={text}
        style={style}
        containerStyle={containerStyle}
      />
    );

  return (
    <View
      style={{
        flexDirection: "row",
        flexWrap: "wrap",
        ...containerStyle,
      }}
    >
      {text?.match(/\w+|\W+/g)?.map((segment, index) => (
        <Text key={index} style={style}>
          {segment.startsWith(" ") ? <>&nbsp;{segment}</> : segment}
        </Text>
      ))}
    </View>
  );
}
